import LegalPage from "../../components/legal/LegalPage";
import document from "../../content/legal/eula.json";

export default function Page() {
  return <LegalPage title="EULA" document={document} />;
}
